import { Route } from '@angular/router';
import { AdminLayoutComponent } from '../features/admin/_ui/admin-layout/admin-layout.component';

const routes: Array<Route> = [
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('../features/admin/admin-dashboard/admin-dashboard.component').then(
            (module) => module.AdminDashboardComponent,
          ),
      },
      {
        path: 'user',
        loadChildren: () =>
          import('../features/admin/admin-user/admin-user.routes').then(
            (module) => module.adminUserRoutes,
          ),
      },
      {
        path: 'maintenance',
        loadComponent: () =>
          import('../features/admin/admin-maintenance/admin-maintenance.component').then(
            (module) => module.AdminMaintenanceComponent,
          ),
      },
      {
        path: 'method',
        loadComponent: () =>
          import('../features/admin/admin-method/admin-method.component').then(
            (module) => module.AdminMethodComponent,
          ),
      },
      {
        path: 'stream',
        loadComponent: () =>
          import('../features/admin/admin-stream/admin-stream.component').then(
            (module) => module.AdminStreamComponent,
          ),
      },
      {
        path: 'platform',
        loadComponent: () =>
          import('../features/admin/admin-platform/admin-platform.component').then(
            (module) => module.AdminPlatformComponent,
          ),
      },
      {
        path: 'chatbot',
        loadComponent: () =>
          import('../features/admin/admin-chatbot/admin-chatbot.component').then(
            (module) => module.AdminChatbotComponent,
          ),
      },
      {
        path: '**',
        loadComponent: () =>
          import('../features/admin/admin-dashboard/admin-dashboard.component').then(
            (module) => module.AdminDashboardComponent,
          ),
      },
    ],
  },
];

export default routes;
